import NavTextNodes from '@data/i18n/nav.json'

import type { LinkResolverFunction } from '@prismicio/client'

// -- Link resolution rules
// Manages the url links to internal Prismic documents
const linkResolver: LinkResolverFunction = (doc: {
	link_type: string
	type: string
	tags: string[]
	uid?: string
	url?: string
}): string => {
	if (doc?.url) {
		return doc.url
	}

	if (doc?.uid) {
		if (doc?.type === 'article') {
			return `${NavTextNodes.theMagUrl}/article/${doc.uid}`
		}

		return `/${doc.uid}`
	}

	return '/'
}

// Export both the new type and the old API compatible version
export default linkResolver as any
